export class ChatViewDTO{
    viajeId: number;
    codigo?: string;
    transportista?: string;
    view: boolean = true;
    viewFooter: boolean = false;
    //Constructor
    constructor(){}; 
}